import i18n from '@/lang'

import { extractValue } from '@/utils/maps'

// 审核状态：  1 审核中 2 审核通过 3 拒绝 4 驳回 5 过期

export function beneficiaryAuditMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.beneficiary_audit_1'),
      type: 'info'
    },
    {
      value: 2,
      label: i18n.t('map.beneficiary_audit_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.beneficiary_audit_3'),
      type: 'danger'
    },
    {
      value: 4,
      label: i18n.t('map.beneficiary_audit_4'),
      type: 'warning'
    },
    {
      value: 5,
      label: i18n.t('map.beneficiary_audit_5'),
      type: 'danger'
    }]
  return extractValue(value, map)
}

export function transactionSettlementStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.transaction_settlement_status_1'),
      type: 'success'
    },
    {
      value: 2,
      label: i18n.t('map.transaction_settlement_status_2'),
      type: 'info'
    }
  ]
  return extractValue(value, map)
}

export function checkoutStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.checkout_status_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.checkout_status_2'),
      type: 'success'
    }, {
      value: 3,
      label: i18n.t('map.checkout_status_3'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

export function loanStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.loan_status_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.loan_status_2'),
      type: 'warning'
    }, {
      value: 3,
      label: i18n.t('map.loan_status_3'),
      type: 'success'
    }, {
      value: 4,
      label: i18n.t('map.loan_status_4'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

export function loanTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.loan_type_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.loan_type_2'),
      type: 'warning'
    }
  ]
  return extractValue(value, map)
}

export function paymentStatusMap(value) {
  const map = [
    {
      value: 2,
      label: i18n.t('map.bill_status_2'), // 还款中
      type: 'processing'
    },
    {
      value: 3,
      label: i18n.t('map.bill_status_3'), // 已还款
      type: 'success'
    },
    {
      value: 4,
      label: i18n.t('map.bill_status_4'), // 已逾期
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

export function billStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.loan_bill_status_1'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('map.loan_bill_status_2'),
      type: 'default'
    }, {
      value: 3,
      label: i18n.t('map.loan_bill_status_3'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

export function NSDSBillStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('merchantAccount.unsettled'),
      type: 'info'
    }, {
      value: 2,
      label: i18n.t('merchantAccount.settled'),
      type: 'default'
    }
  ]
  return extractValue(value, map)
}

// 服务商模式授权状态
export function authorizationStatus(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.authorization_status_1'),
      type: 'info'
    },
    {
      value: 2,
      label: i18n.t('map.authorization_status_2'),
      type: 'success'
    }
  ]
  return extractValue(value, map)
}

// 卡号状态：1-活跃 2-未激活 3-冻结 4-关闭
export function cardAccountStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.card_account_status_1'),
      type: 'success'
    },
    {
      value: 2,
      label: i18n.t('map.card_account_status_2'),
      type: 'info'
    },
    {
      value: 3,
      label: i18n.t('map.card_account_status_3'),
      type: 'warning'
    },
    {
      value: 4,
      label: i18n.t('map.card_account_status_4'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 订单状态：0-待处理 1-处理中 2-成功 3-失败
export function cardOrderStatusMap(value) {
  const map = [
    {
      value: 0,
      label: i18n.t('map.card_order_status_0'),
      type: 'info'
    },
    {
      value: 1,
      label: i18n.t('map.card_order_status_1'),
      type: 'warning'
    },
    {
      value: 2,
      label: i18n.t('map.card_order_status_2'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('map.card_order_status_3'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 姓名匹配状态：0-未验证 1-匹配 2-不匹配
export function cardNameMatchResultMap(value) {
  const map = [
    {
      value: 0,
      label: i18n.t('map.card_name_match_result_0'),
      type: 'info'
    },
    {
      value: 1,
      label: i18n.t('map.card_name_match_result_1'),
      type: 'success'
    },
    {
      value: 2,
      label: i18n.t('map.card_name_match_result_2'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

// 账号类型：1-银行账号 2-电子钱包
export function cardAccountTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('map.card_account_type_1'),
      type: 'info'
    },
    {
      value: 2,
      label: i18n.t('map.card_account_type_2'),
      type: 'info'
    }
  ]
  return extractValue(value, map)
}
